import { drillFragmentData, graphql } from '@e-socna/data-layer';

import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';

import { TimeManagement } from '../../components/Illustrations/TimeManagement';
import { useFolderReadyContext } from '../../contexts/FolderContext/hooks/useFolderReadyContext.hook';
import { formatDate } from '../../utils/format-date.util';

import { FolderPage_Tabs_Folder_Fragment } from './Tabs';

export const FolderPage_ArchiveInfo_Folder_Fragment = graphql(`
  fragment FolderPage_ArchiveInfo_Folder_Fragment on Folder {
    archiveInfo {
      startDateForAnalytics
      endDateForAnalytics
    }
  }
`);

export const ArchiveInfo = () => {
  const { folder: rawFolder } = useFolderReadyContext();
  const folder = drillFragmentData(
    [FolderPage_Tabs_Folder_Fragment, FolderPage_ArchiveInfo_Folder_Fragment],
    rawFolder,
  );

  if (!folder.archiveInfo) {
    return (
      <TimeManagement title="Les données d'archivage ne sont pas encore disponibles" />
    );
  }

  return (
    <Stack spacing={2} sx={{ pt: 4, width: '100%' }}>
      <Typography gutterBottom variant="h6">
        Période
      </Typography>
      <Paper sx={{ p: 2 }}>
        <Box sx={{ position: 'relative' }}>
          <Typography gutterBottom variant="body1">
            Date d&apos;ouverture :{' '}
            {formatDate(folder.archiveInfo.startDateForAnalytics)}
          </Typography>
          <Typography gutterBottom variant="body1">
            Date de fermeture :{' '}
            {formatDate(folder.archiveInfo.endDateForAnalytics)}
          </Typography>
        </Box>
      </Paper>
    </Stack>
  );
};
